// A model's video source limits on the client (the dub's `dubbing.source`: ours, 600 s and
// 200 MB, the platform's bounds on a video source, G7-video-dubbing 6): what a picked file is
// checked against before anything is sent, in live's words.
import type { DubbingSource, VideoLimits } from "../../api/generated/model";

const MB = 1024 * 1024;

/** The source's limits as a slot's tooltip says them (`video/limits.ts`' live formatter). */
export function sourceLimits(source: DubbingSource): VideoLimits {
  return { max_size_mb: Math.floor(source.max_bytes / MB), max_duration_sec: source.max_seconds };
}

/**
 * Live's words for a picked file the source does not take, or null: its size (live's
 * `media-validation` "File is too large"), then its length (the dub's "Choose a video of up to …
 * seconds."). A file whose size or length the library does not know is left to the start, which
 * refuses it at its field in the same words.
 */
export function sourceProblem(
  source: DubbingSource,
  file: { durationMs?: number | null; bytes?: number | null } | null,
): string | null {
  if (file === null) return null;
  if (file.bytes !== null && file.bytes !== undefined && file.bytes > source.max_bytes) {
    const most = Math.floor(source.max_bytes / MB);
    return `File is too large (${(file.bytes / MB).toFixed(1)} MB). Max allowed: ${most} MB.`;
  }
  if (file.durationMs !== null && file.durationMs !== undefined && file.durationMs > source.max_seconds * 1000) {
    return `Choose a video of up to ${source.max_seconds} seconds.`;
  }
  return null;
}
